import { render, staticRenderFns } from "./SmplEditBom.vue?vue&type=template&id=1c48aa5c&scoped=true&"
import script from "./SmplEditBom.vue?vue&type=script&lang=js&"
export * from "./SmplEditBom.vue?vue&type=script&lang=js&"
import style0 from "./SmplEditBom.vue?vue&type=style&index=0&id=1c48aa5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c48aa5c",
  null
  
)

export default component.exports